<template>
  <div>
    <div class="row gutters-tiny">
      <div class="col-6 col-md-4 col-xl-2">
        <tile route="orders" label="Bestellingen" icon="basket"></tile>
      </div>
      <div class="col-6 col-md-4 col-xl-2">
        <tile route="products" label="Producten" icon="tag" icon-class="text-danger"></tile>
      </div>
      <div class="col-6 col-md-4 col-xl-2">
        <tile route="hour_registration" label="Urenregistratie" icon="clock" icon-class="text-success"></tile>
      </div>
    </div>
  </div>
</template>
<script>
import Tile from '../common/Tile'

export default {
  components: {Tile}
}
</script>


// WEBPACK FOOTER //
// OrderPickerDashboard.vue?e9327266